let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gFHfi")).then(() => parcelRequire('27bo9'));